import { useState } from "react";
import { FaFacebookSquare, FaInstagram, FaLinkedin } from "react-icons/fa";
import img from "../assets/Watermark.png";

export default function Footer() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+[1-9]\d{7,14}$/;

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const validate = () => {
    const e = {};

    if (!form.name.trim()) e.name = "Name is required";

    if (!form.phone) {
      e.phone = "Phone number is required";
    } else if (!phoneRegex.test(form.phone)) {
      e.phone = "Enter valid phone with country code (e.g. +919876543210)";
    }

    if (!form.email) {
      e.email = "Email is required";
    } else if (!emailRegex.test(form.email)) {
      e.email = "Enter a valid email address";
    }

    if (!form.message.trim()) e.message = "Message is required";

    return e;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const v = validate();
    setErrors(v);

    if (Object.keys(v).length) return;

    try {
      setLoading(true);

      const result = await sendContactUSToBackend(form);
      // API call here
      if (result.success) {
        setShowSuccess(true);
        setForm({ name: "", phone: "", email: "", message: "" });
        setErrors({});
      } else {
        alert("Failed to send booking: " + result.message);
      }
    } catch (err) {
      console.error(err);
      alert("Error submitting form. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const sendContactUSToBackend = async (formData) => {
    console.log(formData);
    const response = await fetch("https://api.orcaminds.com/hb-ContactUs", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const result = await response.json();

    // Handle HTTP errors
    if (!response.ok) {
      throw new Error(result.message || "Server returned an error");
    }

    return result;
  };

  return (
    <footer className="relative bg-gradient-to-br from-[#06162a] to-[#0b2447] text-white">
      <div className="max-w-7xl mx-auto px-6 py-10 pb-5 grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-14">
        {showSuccess && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
            <div className="bg-white w-[90%] max-w-sm rounded-2xl p-6 text-center shadow-2xl animate-[scaleIn_0.25s_ease-out]">
              {/* Success Icon */}
              <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
                <svg
                  className="h-8 w-8 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>

              {/* Title */}
              <h2 className="text-lg font-bold text-gray-800">
                Contact Details Sent
              </h2>

              {/* Message */}
              <p className="mt-2 text-sm font-semibold text-gray-600">
                Thanks for reaching out! Our team will contact you shortly.
              </p>

              {/* Button */}
              <button
                onClick={() => setShowSuccess(false)}
                className="mt-6 w-full rounded-lg bg-sky-500 py-2.5 text-white font-medium transition hover:bg-sky-600 focus:outline-none focus:ring-2 focus:ring-sky-400"
              >
                Got it
              </button>
            </div>
          </div>
        )}

        {/* LEFT */}
        <div className="space-y-8 space-x-3 md:space-x-[50px] justify-center">
          <div className="absolute ml-3 md:ml-[50px] flex gap-3">
            {[
              {
                Icon: FaFacebookSquare,
                link: "https://www.facebook.com/yourpage",
              },
              {
                Icon: FaInstagram,
                link: "https://www.instagram.com/yourprofile",
              },
              {
                Icon: FaLinkedin,
                link: "https://www.linkedin.com/company/yourcompany",
              },
            ].map(({ Icon, link }, i) => (
              <a
                key={i}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue p-2 rounded-md cursor-pointer hover:bg-blue-500"
              >
                <Icon className="text-2xl sm:text-3xl md:text-4xl" />
              </a>
            ))}
          </div>

          <div className="pt-10 sm:pt-10 md:pt-20">
            <h4 className="font-semibold text-xs sm:text-base md:text-lg mb-1">PHONE NUMBER</h4>
            <p className="text-xs sm:text-base md:text-lg opacity-90">+91 8489245920</p>
          </div>

          <div className="pt-0 md:pt-10">
            <h4 className="font-semibold mb-1 text-xs sm:text-base md:text-lg">LOCATION</h4>
            <p className="opacity-90 text-xs sm:text-base md:text-lg">ALLEPPEY</p>
          </div>
        </div>

        <div className="mt-20 sm:mt-15 md:mt-20" >
          <img
            src={img}
            alt="watermark"
            className="relative w-[100%]  bg-cover bg-center"
          />
        </div>

        {/* RIGHT */}
        <div className="col-span-full md:col-span-1">
          <h4 className="font-semibold text-sm sm:text-base md:text-lg mb-4">CONTACT US</h4>

          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              className={`w-full p-3 bg-transparent border border-white-1000 rounded text-white outline-white ${
                errors.name && "border border-red-500"
              }`}
              placeholder="Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />

            <input
              className={`w-full p-3 bg-transparent border border-white-1000 rounded text-white outline-white ${
                errors.phone && "border border-red-500"
              }`}
              placeholder="Phone No With Country Code"
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
            />

            <input
              className={`w-full p-3 bg-transparent border border-white-1000 rounded text-white outline-white ${
                errors.email && "border border-red-500"
              }`}
              placeholder="Email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />

            <textarea
              className={`w-full p-3 bg-transparent border border-white-1000 rounded text-white outline-white ${
                errors.message && "border border-red-500"
              }`}
              placeholder="Message"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
            />

            <button
              disabled={loading}
              className="bg-sky-500 hover:bg-sky-400 disabled:opacity-60 px-7 py-3 rounded font-semibold flex items-center gap-2"
            >
              {loading && (
                <span className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
              )}
              Submit
            </button>
          </form>
        </div>
      </div>

      {/* FOOTER BOTTOM */}
      <p className="text-center text-sm opacity-80 pb-6">
        All Rights Reserved 2025
      </p>
    </footer>
  );
}
